export default __webpack_public_path__ + "static/media/paragrafo.08b720d1.less";